<template>
  <div id="forbidden">
    <dd-header />
    <main>
      ご利用中のユーザーで許可されない操作が行われました。
    </main>
  </div>
</template>
<script>
import Header from '../components/common/Header'

export default {
  name: 'Forbidden',
  components: {
    'dd-header': Header
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
#forbidden {
  height: calc(100% - 140px);
}
main {
  height: 100%;
  padding: 20px;
  text-align: center;
  background-color: white;
  color: #ff4500;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Forbidden.vue